/** @jsxImportSource @emotion/react */
import { Global, css, jsx } from '@emotion/react'
import React from 'react';
import PageHeader from '@atlaskit/page-header';

const CssReset = <Global styles={css`  
      
      :root {
        --ds-background-subtleNeutral-pressed: rgba(173, 247,220,0.6);
      
      }
      input[type="radio"], input[type="checkbox"] {
        margin: 0;
      }
  // Custom
  
      `}
/>;

export default CssReset;
